// extracted by mini-css-extract-plugin
module.exports = {"contentTypeList":"styles_contentTypeList__27Y3x"};